import type {
  TwoCreateCompanyCreditLimitQuoteRequestType,
  TwoCreateCompanyCreditLimitQuoteResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCreateTwoCompanyCreditLimitQuote = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: TwoCreateCompanyCreditLimitQuoteRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `two/company/credit-limit-quote`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse<TwoCreateCompanyCreditLimitQuoteResponseType>(
            response,
          ).data,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.TwoCreditLimitQuote,
        ],
      });
    },
  });
};
